/* Native details and submit buttons work without JavaScript; enhance dismissal and arrow keys. */
if (!customElements.get('grova-region-selector')) {
  customElements.define('grova-region-selector', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      const groups = [...details.querySelectorAll('details')];
      const close = () => {
        details.open = false;
        groups.forEach(group => { group.open = false; });
      };
      details.addEventListener('toggle', () => {
        if (!details.open) groups.forEach(group => { group.open = false; });
      }, { signal });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) close();
      }, { signal });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) close();
      }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          const activeGroup = groups.find(group => group.open && group.contains(event.target));
          if (activeGroup) {
            activeGroup.open = false;
            activeGroup.querySelector('summary').focus();
          } else {
            close();
            summary.focus();
          }
        }
        if (!['ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        details.open = true;
        const options = [...this.querySelectorAll('button[name="country_code"], .grova-region__group-toggle')]
          .filter(option => groups.every(group => !group.contains(option) || group.open || option === group.querySelector('summary')));
        const current = options.indexOf(document.activeElement);
        const next = current < 0
          ? (event.key === 'ArrowDown' ? 0 : options.length - 1)
          : (current + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options[next]?.focus();
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
